<template>
  <div class="sectionRole" id="role" ref="roleSectionRef">
    <div class="header">
      <p class="big">{{  langDiff ? $t(websiteConfig.role.mainTitle) : websiteConfig.role.mainTitle }}</p>
      <p class="small" v-if="websiteConfig.role.subTitle" >{{langDiff ? $t(websiteConfig.role.subTitle) : websiteConfig.role.subTitle }}</p>
    </div>
    <Swiper
      class="outside-container"
      :class="websiteConfig.role.swiperType || 'normal'"
      :pagination="outsideSwiperConfig"
      :noSwiping="true"
      ref="roleRef"
    >
      <div class="type-pagination" v-if="websiteConfig.role.list.length > 1" @click="clickBtnUpload"></div>
      <SwiperSlide
        v-for="(item, moduleIndex) in websiteConfig.role.list"
        :key="moduleIndex"
        class="swiper-no-swiping"
      >
        <Swiper
          class="inside-container"
          :noSwiping="false"
          :pagination="generateRolePagination(item.roleInfo)"
          :loop="true"
          :threshold="10"
        >
          <div class="avatar-pagination" @click="clickBtnUpload"></div>
          <swiper-slide v-for="(role, roleIndex) in item.roleInfo" :key="roleIndex">
            <div
              class="char rotate"
              :style="{ 'background-image': `url(${role.pic})` }"
              :class="[{ active: !isSupported || targetIsVisible }, websiteConfig.role.swiperType || 'normal']"
            ></div>
            <div class="char-text">
              <p class="name">{{ langDiff ? $t(role.name) : role.name }}</p>
              <div class="split"></div>
              <p class="desc">{{ langDiff ? $t(role.desc) :  role.desc }}</p>
              <div class="skill-wrap">
                <div class="skill-item" v-for="(skill, skillIndex) in role.skill" :key="skillIndex">
                  <div class="skill-pic" :style="{ 'background-image': `url(${skill.pic})` }"></div>
                  <p class="skill-text">{{langDiff ? $t(skill.name) : skill.name }}</p>
                </div>
              </div>
            </div>
            <MediaPlay :detail="role"></MediaPlay>
          </swiper-slide>
        </Swiper>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import roleHook from '@/hooks/roleHook';
import { Swiper, SwiperSlide } from 'swiper/vue';
import MediaPlay from '@/components/role/MediaPlay.vue';
import { clickBtnUpload } from '@/utils/pointUtils';
import SwiperCore, { Pagination } from 'swiper';
const {
  outsideSwiperConfig,
  roleRef,
  roleSectionRef,
  targetIsVisible,
  isSupported,
  websiteConfig,
  langDiff,
  generateRolePagination
} = roleHook();
SwiperCore.use([Pagination]);
</script>
